import type { InferType } from 'yup';
import * as Yup from 'yup';

export const formCardDeckSchema = Yup.object({
  name: Yup
    .string()
    .required('Introduce el nombre del mazo de cartas'),
  nameEn: Yup
    .string()
    .required('Introduce el nombre del mazo de cartas en Ingles'),
  namePt: Yup
    .string()
    .required('Introduce el nombre del mazo de cartas en Portugues'),
  description: Yup
    .string()
    .required('Introduce la descripción del mazo de cartas'),
  descriptionEn: Yup
    .string()
    .required('Introduce la descripción del mazo de cartas en Ingles'),
  descriptionPt: Yup
    .string()
    .required('Introduce la descripción del mazo de cartas en Portugues'),
  packCooldownSeconds: Yup
    .number()
    .required('Introduce el tiempo de cooldown del pack'),
  minCardsPerPack: Yup
    .number()
    .required('Introduce la cantidad mínima de cartas por pack'),
  maxCardsPerPack: Yup
    .number()
    .required('Introduce la cantidad máxima de cartas por pack'),
  coverImageUrl: Yup
    .string()
    .url('Introduce una URL valida (http:// o https://)')
    .required('Introduce la URL de la imagen de portada del mazo de cartas'),
  unrevealedImageUrl: Yup
    .string()
    .url('Introduce una URL valida (http:// o https://)')
    .required('Introduce la URL de la imagen de reverso de las cartas'),
})
  .required();

export type FormCardDeckData = InferType<typeof formCardDeckSchema>;

export const formServerSchema = Yup.object({
  serverId: Yup
    .string()
    .required('Introduce el ID del server'),
  inviteUrl: Yup
    .string()
    .url('Introduce una URL valida, http:// o https://')
    .required('Introduce el URL de la invitacion'),
})
  .required();

export type FormServerData = InferType<typeof formServerSchema>;

export const formTraitSchema = Yup.object({
  name: Yup
    .string()
    .required('Introduce el nombre del trait'),
  nameEn: Yup
    .string()
    .optional()
    .nullable(),
  namePt: Yup
    .string()
    .optional()
    .nullable(),
  layer: Yup
    .number()
    .typeError('La layer debe ser un numero, y mayor o igual a cero')
    .required('Introduce la posicion de la layer'),
})
  .required();

export type FormTraitData = InferType<typeof formTraitSchema>;

export const formVariantSchema = Yup.object({
  name: Yup
    .string()
    .required('Introduce el nombre de la variante'),
  nameEn: Yup
    .string()
    .optional()
    .nullable(),
  namePt: Yup
    .string()
    .optional()
    .nullable(),
  description: Yup
    .string()
    .optional()
    .nullable(),
  descriptionEn: Yup
    .string()
    .optional()
    .nullable(),
  descriptionPt: Yup
    .string()
    .optional()
    .nullable(),
  probability: Yup
    .number()
    .min(0)
    .max(100)
    .typeError('La probabilidad debe ser un numero entre 0 y 100')
    .required('Introduce la probabilidad'),
  imageUrl: Yup
    .string()
    .url('Introduce una URL valida, http:// o https://')
    .required('Introduce la URL de la imagen'),
})
  .required();

export type FormVariantData = InferType<typeof formVariantSchema>;
